<template>
	<v-menu color="white" :nudge-bottom="8" offset-y class="mb-0">
		<template v-if="userSelect" v-slot:activator="{ on, attrs }">
			<v-btn
				v-bind="attrs"
				v-on="on"
				height="48"
				class="select-btn mr-2 mb-2"
				color="background lighten-1"
			>
				<user-select
					:key="selectedUser ? selectedUser.id : selectedUser"
					:user="selectedUser"
				/>
				<v-icon>mdi-chevron-down</v-icon>
			</v-btn>
		</template>

		<v-list class="py-4 list">
			<v-text-field
				v-model="searchValue"
				@click.stop.prevent
				@input="(name) => getUsers(name)"
				placeholder="Szukaj..."
				outlined
				dense
				prepend-inner-icon="mdi-magnify"
				hide-details
				class="mx-4"
			></v-text-field>

			<v-divider class="my-4 mx-4" />

			<Transition name="fade">
				<div v-if="users">
					<v-virtual-scroll
						:items="users"
						:item-height="50"
						height="300"
						:style="{ 'overflow-x': 'hidden' }"
					>
						<template v-slot:default="{ item }">
							<v-list-item
								@click="selectUser(item)"
								link
								class="d-flex"
							>
								<user-select :user="item" />
							</v-list-item>
						</template>
					</v-virtual-scroll>
				</div>
			</Transition>

			<div v-if="!users" class="d-flex justify-center align-center">
				<v-progress-circular indeterminate color="accent" />
			</div>
		</v-list>
	</v-menu>
</template>

<script>
import axios from "axios";

import UserSelect from "@/components/tasks/UserSelect.vue";

export default {
	components: {
		UserSelect,
	},
	props: {
		userSelect: {
			type: Boolean,
			default: true,
		},
		user: {
			type: Object,
		},
	},
	data() {
		return {
			searchValue: "",
			users: "",
			selectedUser: this.user,
		};
	},
	created() {
		this.getUsers();
	},
	methods: {
		async getUsers() {
			await axios
				.get("users/company", {
					params: { name: this.searchValue },
				})
				.then((response) => {
					this.users = response.data.data;
				})
				.catch((e) => {
					console.log("GET USER ERROR", e);
				});
		},

		selectUser(user) {
			this.selectedUser = user;
			this.$emit("selectUser", user.id);
		},
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.v-menu__content.v-menu__content--fixed.menuable__content__active {
	background-color: var(--v-background-lighten1) !important;
}
</style>
